import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
// Assets
import CloseIcon from '../../assets/svg/CloseIcon';
import LogoImg from '../../assets/img/CITRIN-Logo.png';
import { useLocation } from 'react-router-dom';

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
    const [isWelcomePage, setIsWelcomePage] = useState(true);
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/welcome') {
            setIsWelcomePage(true);
        } else {
            setIsWelcomePage(false);
        }
    }, []);

    return (
        <Wrapper className="animate darkBg" $sidebarOpen={sidebarOpen}>
            <SidebarHeader className="flexSpaceCenter">
                <div className="flexNullCenter">
                    <Link className="pointer flexNullCenter" to="home">
                        <img src={LogoImg} alt="citrin" width="50" height="50" />
                        <h2 className="whiteColor font20" style={{ marginLeft: '10px' }}>
                            CITRIN Mobility
                        </h2>
                    </Link>
                </div>
                <CloseBtn onClick={() => toggleSidebar(!sidebarOpen)} className="animate pointer">
                    <CloseIcon />
                </CloseBtn>
            </SidebarHeader>

            <UlStyle
                className="flexNullCenter flexColumn"
                style={isWelcomePage ? { display: '' } : { display: 'none' }}
            >
                <li className="semiBold font15 pointer">
                    <Link
                        onClick={() => toggleSidebar(!sidebarOpen)}
                        activeClass="active"
                        className="whiteColor"
                        style={{ padding: '10px 15px' }}
                        to="home"
                        spy={true}
                        offset={-60}
                    >
                        Home
                    </Link>
                </li>
                <li className="semiBold font15 pointer">
                    <Link
                        onClick={() => toggleSidebar(!sidebarOpen)}
                        activeClass="active"
                        className="whiteColor"
                        style={{ padding: '10px 15px' }}
                        to="citrinVision"
                        spy={true}
                        offset={-60}
                    >
                        CITRIN Vision
                    </Link>
                </li>
                <li className="semiBold font15 pointer">
                    <Link
                        onClick={() => toggleSidebar(!sidebarOpen)}
                        activeClass="active"
                        className="whiteColor"
                        style={{ padding: '10px 15px' }}
                        to="b2b"
                        spy={true}
                        offset={-60}
                    >
                        B2B
                    </Link>
                </li>
                <li className="semiBold font15 pointer">
                    <Link
                        onClick={() => toggleSidebar(!sidebarOpen)}
                        activeClass="active"
                        className="whiteColor"
                        style={{ padding: '10px 15px' }}
                        to="sustainablity"
                        spy={true}
                        offset={-60}
                    >
                        Sustainablity
                    </Link>
                </li>
                <li className="semiBold font15 pointer">
                    <Link
                        onClick={() => toggleSidebar(!sidebarOpen)}
                        activeClass="active"
                        className="whiteColor"
                        style={{ padding: '10px 15px' }}
                        to="partners"
                        spy={true}
                        offset={-60}
                    >
                        Partners
                    </Link>
                </li>
                <li className="semiBold font15 pointer">
                    <Link
                        onClick={() => toggleSidebar(!sidebarOpen)}
                        activeClass="active"
                        className="whiteColor"
                        style={{ padding: '10px 15px' }}
                        to="contact"
                        spy={true}
                        offset={-60}
                    >
                        Contact
                    </Link>
                </li>
            </UlStyle>
            <UlStyle className="flexSpaceCenter">
                <li className="semiBold font15 pointer">
                    <a href="login" style={{ padding: '10px 30px 10px 0' }} className="whiteColor">
                        Log-in B2B
                    </a>
                </li>
                <li className="semiBold font15 pointer flexCenter">
                    <a href="citrin-taxi-welcome" className="radius8 lightBg" style={{ padding: '10px 15px' }}>
                        CITRIN Taxi
                    </a>
                </li>
            </UlStyle>
        </Wrapper>
    );
}

const Wrapper = styled.nav`
    width: 400px;
    height: 100vh;
    position: fixed;
    top: 0;
    padding: 0 30px;
    right: ${(props) => (props.$sidebarOpen ? '0px' : '-400px')};
    z-index: 9999;
    @media (max-width: 400px) {
        width: 100%;
    }
`;
const SidebarHeader = styled.div`
    padding: 20px 0;
`;
const CloseBtn = styled.button`
    border: 0px;
    outline: none;
    background-color: transparent;
    padding: 10px;
`;
const UlStyle = styled.ul`
    padding: 10px;
    li {
        margin: 20px 0;
    }
`;
